import { User } from "@tendercuts/models";
import { Constants } from "@app/env";
import { Injectable } from "@angular/core";
import { Store } from "@ngrx/store";
import { AppState } from "@store/state";

@Injectable({
  providedIn: "root",
})
export class EndPoint {
  public baseUrl: string;
  public _cdn: string;

  constructor(public constants: Constants, public store: Store<AppState>) {
    this._cdn = constants.CDN;
    this.baseUrl = constants.API_URL;
  }

  get cdn() {
    return this._cdn;
  }

  get login() {
    return this.baseUrl + "pos/login/";
  }

  placeOrder() {
    return `${this.baseUrl}pos/delayed_sync`;
  }

  placeComboOrder() {
    return `${this.baseUrl}pos/instant_sync/`;
  }

  get searchPosCustomer() {
    return `${this.baseUrl}pos/customer_search`;
  }

  get validateCouponCode() {
    return `${this.baseUrl}pos/discount`;
  }

  storeEndpoint() {
    return this.baseUrl + "core/store/";
  }

  orderHistory() {
    return `${this.baseUrl}pos/today_orders/`;
  }

  storeAddressEndpoint() {
    return `${this.baseUrl}core/store_address/`;
  }

  outOfStockProduct() {
    return `${this.baseUrl}inventory/pos/outofstock`;
  }

  carryBagRewards() {
    return `${this.baseUrl}pos/refund_carry`;
  }

  sendOtp() {
    return `${this.baseUrl}pos/void_billing/`;
  }

  storePhoneNumber() {
    return `${this.baseUrl}pos/void_billing`;
  }

  reSendOtp() {
    return `${this.baseUrl}otp/retry/`;
  }

  validateOtp() {
    return `${this.baseUrl}otp/verify/`;
  }

  onlineOrders() {
    return `${this.baseUrl}pos/live_orders`;
  }

  markAsComplete() {
    return `${this.baseUrl}pos/complete_order/`;
  }

  pinelabsUploadTxnEndpoint(){
    return `${this.baseUrl}pos/pinelabs/upload_txn/`;
  }

  pinelabsCancelTxnEndpoint(){
    return `${this.baseUrl}pos/pinelabs/cancel_txn/`;
  }

  pinelabsCheckTxnEndpoint(){
    return `${this.baseUrl}pos/pinelabs/check_txn_status/`;
  }

  storeEdcMachines() {
    return `${this.baseUrl}pos/edc_machines/`;
  }
  
  getStoreConfig() {
    return `${this.baseUrl}core/store_config/`;
  }
}
